var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"joined-circles"},[_c('svg',{staticClass:"joined-circles__content",attrs:{"id":`joined-circles-content-svg-${_vm.indexingKey}`,"width":_vm.width,"height":_vm.height,"label":_vm.label,"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }